export default function initPageWithAsideNav() {
    const $pageAside = document.querySelector<HTMLElement>('.js-page-aside');

    if ($pageAside) {
        new PageWithAsideNav($pageAside);
    }
}

class PageWithAsideNav {
    $pageAside: HTMLElement;
    $nav: HTMLElement;
    $navMenu: HTMLElement;
    $navMenuToggler: HTMLElement;
    navMenuHeight = 0;

    constructor($pageAside: HTMLElement) {
        this.$pageAside = $pageAside;
        this.$nav = this.$pageAside.querySelector('.js-page-aside-nav') as HTMLElement;
        this.$navMenu = this.$pageAside.querySelector('.js-page-aside-nav-menu') as HTMLElement;
        this.$navMenuToggler = this.$pageAside.querySelector('.js-page-aside-nav-menu-toggler') as HTMLElement;

        this.initLinks();
        this.initMobile();

        window.addEventListener('resize', () => {
            this.initMobile();
        });
    }

    initMobile() {
        const breakpointLg = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg'));

        // On sort de la fonction si on est sur le breakpoint LG
        if (window.innerWidth >= breakpointLg) {
            // On détruit la config si le composant était déjà initialisé
            if (this.$pageAside.classList.contains('initialized')) {
                this.destroyMobile();
            }

            return;
        }

        // On rend le UL de la navigation non focusable (il a un overflow)
        this.$navMenu.setAttribute('tabindex', '-1');

        // Reset du height du UL de la navigation + recalcul de sa véritable hauteur
        this.$navMenu.classList.add('open-no-transition');
        this.$navMenu.style.height = '';
        this.navMenuHeight = this.$navMenu.offsetHeight;
        this.$navMenu.style.height = '0';
        this.$navMenu.classList.remove('open-no-transition');
        this.closeMobileNavMenu();

        // Si le composant était déjà initialisé, on s'arrête ici
        if (this.$pageAside.classList.contains('initialized')) {
            return;
        }

        this.$pageAside.classList.add('initialized');

        // Toggle du sommaireau clique sur le bouton de toggle
        this.$navMenuToggler.addEventListener('click', () => {
            this.toggleMobileNavMenu();
        });

        // Fermeture du sommaire au clique sur les liens à l'intérieur
        this.$navMenu.querySelectorAll('a[href]').forEach($link => {
            $link.addEventListener('click', () => {
                this.closeMobileNavMenu();
            });
        });

        // Fermeture du sommaire au clique en dehors de celui-ci
        document.addEventListener('click', (evt: MouseEvent) => {
            const $target = evt.target as HTMLElement;

            if (this.isMobileNavMenuOpen() && !$target.closest('.js-page-aside')) {
                this.closeMobileNavMenu();
            }
        });
    }

    /**
     * Ajout de fake-anchor sur les éléments sur lesquels pointent les liens du sommaire
     * 
     * @return {void}
     */
    initLinks(): void {
        this.$navMenu.querySelectorAll<HTMLAnchorElement>('a[href]').forEach($link => {
            const identifier = ($link.getAttribute('href') as string).replace('#', '');
            const $target = document.getElementById(identifier);

            if ($target) {
                // Creation de la div fake-anchor
                const $fakeAnchor = document.createElement('div');
                $fakeAnchor.classList.add('fake-anchor');
                $fakeAnchor.id = identifier;

                $target.removeAttribute('id');
                $target.prepend($fakeAnchor);
            }
        });
    }

    /**
     * Retourne si le sommaire est ouvert ou non
     * 
     * @return {boolean}
     */
    isMobileNavMenuOpen(): boolean {
        return this.$nav.classList.contains('open');
    }

    /**
     * Ouvre ou ferme le sommaire en fonction de son état actuel
     * 
     * @return {void}
     */
    toggleMobileNavMenu(): void {
        if (this.isMobileNavMenuOpen()) {
            this.closeMobileNavMenu();
        } else {
            this.openMobileNavMenu();
        }
    }

    /**
     * Ouvre le sommaire
     * 
     * @return {void}
     */
    openMobileNavMenu(): void {
        this.$nav.classList.add('open');
        this.$navMenu.style.height = this.navMenuHeight + 'px';
        this.$navMenu.setAttribute('aria-hidden', 'false');
    }

    /**
     * Ferme le sommaire
     * 
     * @return {void}
     */
    closeMobileNavMenu(): void {
        this.$nav.classList.remove('open');
        this.$navMenu.style.height = '0';
        this.$navMenu.setAttribute('aria-hidden', 'true');
    }

    /**
     * Détruit la config du composant
     * 
     * @return {void}
     */
    destroyMobile(): void {
        this.$nav.classList.remove('open');
        this.$navMenu.removeAttribute('aria-hidden');
        this.$navMenu.removeAttribute('tabindex');
        this.$navMenu.style.height = '';
    }
}
